import styled from 'styled-components';
import omitProps from "../helpers/omitProps";
import { elevation } from "../Styles/Utils";

export const Container = /*#__PURE__*/styled.div.withConfig({ displayName: "styles__Container", componentId: "sc-1gyfqe9-0" })(["display:flex;align-items:center;", ""],



({ disabled }) =>
disabled ? 'pointer-events: none; opacity: .5;' : '');


export const Input = /*#__PURE__*/styled(omitProps('accentColor', 'intermediate')('input')).withConfig({ displayName: "styles__Input", componentId: "sc-1gyfqe9-1" })(["position:absolute;height:0;width:0;visibility:hidden;appearance:none;&:checked + label{background:", ";", "}&:checked + label:after{left:calc(100% - 4px);transform:translateX(-100%);background:", ";", "}"],







({ intermediate, theme }) =>
intermediate ? theme.colors.caution : theme.colors.positive,
elevation(-1, false),





({ theme }) => theme.colors.Background,
elevation(1, false));



export const Label = /*#__PURE__*/styled.label.withConfig({ displayName: "styles__Label", componentId: "sc-1gyfqe9-2" })(["cursor:pointer;text-indent:-9999px;width:48px;height:24px;display:flex;align-items:center;border-radius:50px;position:relative;transition:150ms ease-out;background:", ";&:after{content:'';position:absolute;left:4px;width:16px;height:16px;border-radius:16px;transition:150ms ease-out;background:", ";}&:active:after{width:24px;}"],









({ theme }) => theme.colors['Level 1'],









({ theme }) => theme.colors['Level 5']);